import { parseDollarAmt } from "./parseDollarAmt";

export function getFlexitiInstallment(price: number) {
  const dollarPrice = parseDollarAmt(price);
  let months = 3;
  if (dollarPrice === "0") {
    return 0;
  }
  if (dollarPrice > 1800) {
    months = 24;
  } else if (dollarPrice > 600) {
    months = 12;
  } else if (dollarPrice > 300) {
    months = 6;
  }
  return price / months;
}
